import { render, staticRenderFns } from "./StateInformationNeeded.vue?vue&type=template&id=572099bc&scoped=true&lang=html&"
import script from "./StateInformationNeeded.vue?vue&type=script&lang=js&"
export * from "./StateInformationNeeded.vue?vue&type=script&lang=js&"
import style0 from "./StateInformationNeeded.vue?vue&type=style&index=0&id=572099bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572099bc",
  null
  
)

component.options.__file = "StateInformationNeeded.vue"
export default component.exports